
















import { Component, Vue, Watch } from 'vue-property-decorator';
import HotNews from './components/Hot/index.vue';
import InnerNews from './components/Inner/index.vue';
import Honor from './components/Honor/index.vue';
import topBg from '@/assets/images/news/topBg.jpg';
import { scrollToAnchor } from '@/utils/common';
@Component({
  name: 'News',
  components: {
    HotNews,
    InnerNews,
    Honor,
  },
})
export default class extends Vue {
  imageData = {
    topBg,
  };

  mounted() {
    scrollToAnchor(this.$route.hash);
  }

  @Watch('$route')
  onRouteChange({ hash }) {
    this.$nextTick(() => {
      scrollToAnchor(hash);
    });
  }
}
